import { render } from "./UploadDocuments.vue?vue&type=template&id=1c8c2f9f&scoped=true&ts=true"
import script from "./UploadDocuments.vue?vue&type=script&lang=ts"
export * from "./UploadDocuments.vue?vue&type=script&lang=ts"

import "./UploadDocuments.vue?vue&type=style&index=0&id=1c8c2f9f&scoped=true&lang=css"

import exportComponent from "D:\\Github\\guardsonlinesms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8c2f9f"]])

export default __exports__